module.exports = {
  bottle: ['https://i.cloudup.com/y29czRwU3R.m4a', 'https://i.cloudup.com/baNnhH1I7M.ogg'],
  funk: ['https://i.cloudup.com/KkfWRzYC77.m4a', 'https://i.cloudup.com/7SSbOm5XZS.ogg'],
  glass: ['https://i.cloudup.com/E021I9zUG3.m4a', 'https://i.cloudup.com/3gveeCqUD6.ogg'],
  morse: ['https://i.cloudup.com/h7r7MsF4q3.m4a', 'https://i.cloudup.com/b0EXCVaceT.ogg'],
  pop: ['https://i.cloudup.com/vTka9yOizT.m4a', 'https://i.cloudup.com/4TnDj0v9GE.ogg'],
  purr: ['https://i.cloudup.com/5HJSHCtOzZ.m4a', 'https://i.cloudup.com/YdDNGA0sj5.ogg'],
  submarine: ['https://i.cloudup.com/r4ZENSF0Hu.m4a', 'https://i.cloudup.com/2OPb5OYAI2.ogg'],
  tink: ['https://i.cloudup.com/nCtoNq3kJN.m4a', 'https://i.cloudup.com/SNi1RX8iwb.ogg']
};
